import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor() { }

  searchQuery$ : BehaviorSubject<any> = new BehaviorSubject<any>(null);
}
